// Copyright (c) Docugami, Inc. All rights reserved.

import styled from "styled-components"
import React from 'react';
import { emptyColor } from "components/shell/presentation/AppStyles";

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
`;

const ListItemContainer = styled.div`
    width: 100%;
    :not(:last-child) {
        border-bottom: 1px solid ${emptyColor};
    }
    box-sizing: border-box;
    padding: 5px;
    padding-bottom: 15px;
`;

export interface INotificationListItem {
    key: string;
    value: JSX.Element;
}

interface NotificationsListProps {
    notifications: INotificationListItem[];
}

/**
 * List of notification items.  It is expected that a higher order component provides
 * the notifications to be displayed.
 */
export const NotificationsList = (props: NotificationsListProps): JSX.Element => {
    return (
        <ListContainer>
            { props.notifications.map(item => {
                return (
                    <ListItemContainer key={item.key}>
                        {item.value}
                    </ListItemContainer>
                );
            })}
        </ListContainer>
    );
}
